$(document).ready(function () {
  const orderedTitles = [
    "frame size", "bridge width", "temple length", "lens height", "lens width",
    "fit", "rim type", "model number", "made in", "frame color", "lens color",
    "frame shape", "frame material", "whats included"
  ];

  function reorderElements() {
    $('.table_new').each(function () {
      const $container = $(this);
      const $allRows = $container.find('.table_1');

      const orderedElements = [];
      const unorderedElements = [];

      // Go through each row and categorize
      $allRows.each(function () {
        const titleText = $(this).find('.title').text().trim().toLowerCase();
        if (orderedTitles.includes(titleText)) {
          orderedElements.push($(this));
        } else {
          unorderedElements.push($(this));
        }
      });

      // Clear container
      $container.empty();

      if (window.innerWidth >= 991) {
        // Reorder in alternating (2-column) layout
        const half = Math.ceil(orderedElements.length / 2);
        for (let i = 0; i < half; i++) {
          if (orderedElements[i]) $container.append(orderedElements[i]);
          if (orderedElements[i + half]) $container.append(orderedElements[i + half]);
        }
      } else {
        // For mobile: simple top-down order
        orderedElements.forEach($el => $container.append($el));
      }

      // Always append unordered rows at the end
      unorderedElements.forEach($el => $container.append($el));
    });
  }

  reorderElements();
  $(window).resize(reorderElements);


  // Breadcrumbs scroll behavior
  document.addEventListener("DOMContentLoaded", function () {
    const breadcrumbs = document.querySelector(".breadcrumbs");
    if (!breadcrumbs) return;

    let isDown = false, startX, scrollLeft;

    breadcrumbs.addEventListener("mousedown", (e) => {
      isDown = true;
      startX = e.pageX - breadcrumbs.offsetLeft;
      scrollLeft = breadcrumbs.scrollLeft;
    });

    breadcrumbs.addEventListener("mouseleave", () => isDown = false);
    breadcrumbs.addEventListener("mouseup", () => isDown = false);

    breadcrumbs.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - breadcrumbs.offsetLeft;
      const walk = (x - startX) * 2;
      breadcrumbs.scrollLeft = scrollLeft - walk;
    });
  });
});
